<form *ngIf="!submitted" [formGroup]="form" class="modal-main my-modal">
    <div class="modal-head my-modal__header">
        <h1>Recharge Business</h1>
    </div>
    <div class="my-modal__flex">
        <div class="my-modal__flex_basis">
            <h3>User Name:</h3>
        </div>
        <div class="my-modal__flex_basis">
            <p>{{ user?.firstName }} {{ user?.lastName }}</p>
        </div>
        <div class="my-modal__flex_basis">
            <h3>CNIC:</h3>
        </div>
        <div class="my-modal__flex_basis">
            <p>{{ user?.cnic }}</p>
        </div>
        <div class="my-modal__flex_basis">
            <h3>Current Blance:</h3>
        </div>
        <div class="my-modal__flex_basis">
            <p>{{ user?.balance }}</p>
        </div>
        <div class="my-modal__flex_basis">
            <h3>Recharge Amount:</h3>
        </div>
        <div class="my-modal__flex_basis form-group">
            <input type="number" formControlName="amount" class="form-control" name="" id="amount">
            <small *ngIf="!form.valid">Please enter valid amount.</small>
        </div>
        <div class="my-modal__flex_basis">
            <h3>Is FOC:</h3>
        </div>
        <div class="my-modal__flex_basis form-group form-check">
            <input type="checkbox" formControlName="isFOC" class="form-check-input" name="" id="isFOC">
        </div>
        <div class="my-modal__button">
            <app-button (click)="submit()" [disabled]="!form.valid">Recharge</app-button>
        </div>
    </div>
</form>

<form *ngIf="submitted && success" [formGroup]="form" class="my-modal">
    <div class="modal-head my-modal__header">
        <h1>Recharge User</h1>
    </div>
    <div class="my-modal__icon">
        <img src="assets/images/popup.png">
    </div>
    <div class="modalbody my-modal__text">
        <p>Recharge of PKR {{ form.value.amount }} was successful.</p>
    </div>
    <div class="my-modal__button">
        <app-button (click)="close()">OK</app-button>
    </div>
</form>